import { pick } from "@styled-system/props";
import { Box, Stack, SystemProps, Text } from "flicket-ui";
import { CountdownTimer } from "~components";
import { useOrganization } from "~hooks";
import { formatEventDate } from "~lib/helpers/formatDate";
import { PageContext } from "../hooks/useDetailsPageContext";
import { ctaStateFromPageContext } from "../utils/pageStateFromContext";
import EventCTACard from "./events.EventCTACard";
import MainCTA from "./events.MainCTA";
import ReleaseCodes from "./events.ReleaseCodes";

interface PresaleCountdownProps extends SystemProps {
  pageContext: PageContext;
  showReleaseCodes?: boolean;
}

interface CTACountdownProps extends SystemProps {
  countdownTo: Date;
  pageContext: PageContext;
}

export const CTACountdown = ({
  pageContext,
  countdownTo,
  ...props
}: CTACountdownProps) => {
  return (
    <Stack
      width={"100%"}
      alignItems={"center"}
      direction="vertical"
      gap={1}
      backgroundColor="N100"
      px={3}
      py={2}
      {...pick(props)}
    >
      <Stack>
        <Text variant="regular" fontSize={2}>
          <b>
            {pageContext.state === "active-presale" ||
            pageContext.state === "registration" ||
            pageContext.state === "registration-competition" ||
            pageContext.state === "info"
              ? "Public sale starts:"
              : "Presale starts:"}
          </b>{" "}
          {formatEventDate(countdownTo.toISOString(), "datetime", {
            timeZone: pageContext.event?.venue?.timezone,
            locale: pageContext.event?.venue?.locale,
          })}
        </Text>
      </Stack>
      <CountdownTimer
        countdownTo={countdownTo}
        onComplete={() => window?.location?.reload()}
      />
    </Stack>
  );
};

export const CTACard = ({
  pageContext,
  showReleaseCodes,
  ...props
}: PresaleCountdownProps) => {
  const { hasFeature } = useOrganization();
  const event = pageContext.event;
  const {
    ctaTitle,
    countdownTo,
    competitionCTACardProps,
  } = ctaStateFromPageContext(pageContext);

  const showCTACard = !(
    hasFeature("hideMainSaleCountdown") && pageContext.state === "info"
  );

  return (
    <Box flex={"0 0 370px"} {...pick(props)}>
      {showCTACard && (
        <EventCTACard title={ctaTitle} {...competitionCTACardProps}>
          {/* If presale is not yet live, or if there is no linked presale, show the registration button. presaleStartTime will be null if no presale linked. */}
          {pageContext.state !== "info" && (
            <MainCTA pageContext={pageContext} />
          )}
          {countdownTo && (
            <CTACountdown pageContext={pageContext} countdownTo={countdownTo} />
          )}
        </EventCTACard>
      )}

      {showReleaseCodes && (
        <EventCTACard title="Have an access code?" mt={4}>
          <Box>
            <ReleaseCodes event={event} />
          </Box>
        </EventCTACard>
      )}
    </Box>
  );
};
